<footer>
  <ul class="footer-list">
    @if (authenticatedUser() == null) {
      <li>
        <button class="footer-button" rel="noopener" (click)="login()" title="Login">Login</button>
      </li>
    }
    @if (authenticatedUser() != null) {
      <li class="userLabel">
        Logged in as:&nbsp;<span class="name">{{authenticatedUser()?.name}}</span>&nbsp;<span class="userName">({{authenticatedUser()?.username}})</span>
      </li>
    }
    @if (authenticatedUser != null) {
      <li class="userLabel">
        <button class="footer-button" title="Log Out" color="primary" (click)="logOff()">Log Out</button>
      </li>
    }
    @if (environment?.toLowerCase() != 'production') {
      <li>
        Environment: {{environment}}
      </li>
    }
  </ul>
</footer>
